/** Public/free/disposable domains — keep in sync with accounts.utils.is_public_email_domain. */
export const PUBLIC_EMAIL_DOMAINS = new Set([
    'gmail.com',
    'googlemail.com',
    'yahoo.com',
    'yahoo.co.uk',
    'yahoo.ca',
    'yahoo.de',
    'yahoo.fr',
    'yahoo.it',
    'yahoo.es',
    'hotmail.com',
    'outlook.com',
    'live.com',
    'msn.com',
    'aol.com',
    'aim.com',
    'icloud.com',
    'me.com',
    'mac.com',
    'protonmail.com',
    'tutanota.com',
    'mail.com',
    'gmx.com',
    'gmx.de',
    'gmx.at',
    'gmx.ch',
    'yandex.com',
    'yandex.ru',
    'zoho.com',
    'fastmail.com',
    'hushmail.com',
    'guerrillamail.com',
    '10minutemail.com',
    'tempmail.org',
    'mailinator.com',
    'throwaway.email',
    'dispostable.com',
    'sharklasers.com',
    'getairmail.com',
    'getnada.com',
    'inboxkitten.com',
    'mailnesia.com',
    'mintemail.com',
    'spam4.me',
    'bccto.me',
    'chacuo.net',
    'guerrillamailblock.com',
    'mailmetrash.com',
    'mailnull.com',
    'mohmal.com',
    'nwytg.net',
    'pokemail.net',
    'rcpt.at',
    'spamspot.com',
    'spam.la',
    'tempmailaddress.com',
    'thisisnotmyrealemail.com',
    'tmailinator.com',
    'trashmail.net',
    'wegwerfemail.de',
    'wegwerfemail.net',
    'wegwerfemail.org',
    'wh4f.org',
    'whyspam.me',
    'wuzup.net',
    'xemaps.com',
    'xents.com',
    'yopmail.com',
    'yopmail.net',
    'yopmail.org',
    'yuurok.com',
    'z1p.biz',
    'zehnminutenmail.de',
    'zehnminutenmail.net',
    'zehnminutenmail.org',
    'zehnminutenmail.com',
]);

export const INVALID_EMAIL_MESSAGE = 'Enter Valid Email Address';
export const PUBLIC_EMAIL_MESSAGE =
    'Public email addresses are not allowed. Please use a company email address.';

export function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

export function isPublicEmailDomain(email) {
    const value = String(email || '').trim();
    if (!value || !value.includes('@')) return false;
    const domain = value.split('@').pop().toLowerCase();
    return PUBLIC_EMAIL_DOMAINS.has(domain);
}

export function isWorkEmail(email) {
    const value = String(email || '').trim();
    return isEmail(value) && !isPublicEmailDomain(value);
}

export function workEmailError(email) {
    const value = String(email || '').trim();
    if (!value) return '';
    if (!isEmail(value)) return INVALID_EMAIL_MESSAGE;
    if (isPublicEmailDomain(value)) return PUBLIC_EMAIL_MESSAGE;
    return '';
}
